module.exports = __webpack_public_path__ + "static/media/stacks-pharmacy.6eb2e547.png";